import
  React, {
  useEffect,
  useState
} from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  Base
} from '@vodacom/web-common';

import {
  CustomColors
} from '../../constants';

import {
  Tab
} from './Tab';

import {
  isEqual
} from 'helpers';

const Container = styled(Base)`
  display: flex;
  flex: ${props => props.flex || '1 0 auto'};
  justify-content: ${props => props.justifyContent || 'center'};
`;

export const TabBar = (props) => {

  const [ activeTab, setActiveTab ] = useState(props.defaultTabValue || null);

  useEffect(() => {
    setActiveTab(props.defaultTabValue);
  }, [ props.defaultTabValue ]);

  if (!props.tabs) {
    return null;
  }

  const onTabClicked = (tab) => {

    props?.onTabClicked?.(tab);
    setActiveTab(tab.value);
  };

  const tabs = [];
  let tab;

  for (let i = 0; i < props.tabs.length; i ++) {

    tab = props.tabs[i];

    if (!tab || !Object.keys(tab).length) {
      continue;
    }

    const active = (isEqual(tab.value, activeTab) || (!activeTab && i === 0));

    tabs.push(

      <Tab
        id={`${props.id}_${tab.label}`}
        automationId={`${props.automationId}_${tab.label}`}
        onTabClicked={onTabClicked}
        value={tab.value}
        label={tab.label}
        active={active}
        borderBottom={(active && props.activeBorderBottom) || props.inActiveBorderBottom}
        name={tab.name}
        key={`tab-${props.id}-label-${i}`}
        activeColor={props.activeColor}
        inactiveColor={props.inactiveColor}
        fontSize={props.fontSize}
        margin='0 10px'
        position={props.borderBottom ? 'relative' : undefined}
        bottom={props.borderBottom ? props.borderBottomSize : undefined}
      />
    );
  }

  return (

    <Container
      id={props.id}
      automationId={props.automationId}
      flex={props.flex}
      padding={props.padding}
      margin={props.margin}
      minHeight={props.minHeight}
      minWidth={props.minWidth}
      maxHeight={props.maxHeight}
      maxWidth={props.maxWidth}
      width={props.width}
      justifyContent={props.justifyContent}
      borderBottom={props.borderBottom}>

        {tabs}
    </Container>
  );
};

TabBar.propTypes = {
  ...Base.propTypes,
  automationId: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ])
    })
  ),
  onTabClicked: PropTypes.func,
  defaultTabValue: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  fontSize: PropTypes.string,
  width: PropTypes.string,
  activeColor: PropTypes.string,
  inActiveColor: PropTypes.string,
  activeBorderBottom: PropTypes.string,
  inActiveBorderBottom: PropTypes.string,
  borderBottom: PropTypes.string,
  borderBottomSize: PropTypes.string
};

TabBar.defaultProps = {
  ...Base.defaultProps,
  id: 'unknown-tab-bar',
  automationId: 'unknown-tab-bar',
  justifyContent: 'left',
  width: null,
  tabs: [],
  onTabClicked: () => {},
  defaultTabValue: null,
  fontSize: undefined,
  activeColor: CustomColors.Red1,
  inActiveColor: CustomColors.Grey9,
  activeBorderBottom: `solid 3px ${CustomColors.Red1}`,
  inActiveBorderBottom: `solid 3px ${CustomColors.Transparent}`,
  borderBottom: null,
  borderBottomSize: null
};
